import React from 'react';
import { array, bool, func, number, object } from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { translate } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import {
    alignPackagesFeatures,
    getPackageTypeById,
    hasRecommendedPackage,
} from '../../../utils/packagesUtils';
import TabContent from '../TabContent';
import { selectPackage } from '../../../actions/packages';
import { reportTabClickEvents } from './utils';

import './style.scss';

const TriplePackage = (
    { packageList, selectedPackageId, selectPackage, customOrder },
    { biEvents, isBusinessLayout, isProRebrandingLayout }
) => {

    const onPackageChange = (id, reportTabClick = true) => {
        selectPackage({ packageId: id });

        if (reportTabClick) {
            reportTabClickEvents(biEvents, id);
        }
    };

    const recommendedGig = hasRecommendedPackage(packageList);
    const selectedPackage = packageList.find((packageData) => packageData.id === selectedPackageId);
    const tabContentProps = {
        id: selectedPackage.id,
        features: selectedPackage.features,
        recommendedGig,
        customOrder,
    };
    const packageListItemClasses = classnames({
        'new-pro-layout': isBusinessLayout || isProRebrandingLayout,
    });

    return (
        <Container className={classnames('packages-tabs', 'triple')}>
            {packageList.map(({ id }) => (
                <input
                    key={id}
                    id={`package-tab-${id}`}
                    name="package-tab-group"
                    type="radio"
                    checked={selectedPackageId === id}
                />
            ))}

            <Container className="nav-container">
                {packageList.map(({ id }) => (
                    <label
                        key={id}
                        htmlFor={`package-tab-${id}`}
                        className={packageListItemClasses}
                        tabIndex="0"
                        role="tab"
                        aria-selected={selectedPackageId === id}
                        onClick={() => onPackageChange(id)}
                    >
                        {translate(getPackageTypeById(id))}
                    </label>
                ))}
            </Container>
            <TabContent {...tabContentProps} />
        </Container>
    );
};

TriplePackage.propTypes = {
    packageList: array,
    selectedPackageId: number,
    selectPackage: func,
    customOrder: object,
};

TriplePackage.contextTypes = {
    biEvents: object,
    isBusinessLayout: bool,
    isProRebrandingLayout: bool,
};

const mapStateToProps = (state) => {
    const { packages } = state;

    return {
        packageList: alignPackagesFeatures(packages.packageList),
        selectedPackageId: packages.selectedPackageId,
        customOrder: state.customOrder,
    };
};

export { TriplePackage };
export default connect(mapStateToProps, { selectPackage })(TriplePackage);
